import { useTranslation } from 'react-i18next';

import { useField } from 'formik';
import { MultiAccountField } from 'fields';
import { APP_PRODUCT_TYPE } from 'appConstants';
import { useMultiAccounts } from 'contexts/MultiAccounts';
import { useCallback, useEffect } from 'react';

export default function MultiAccount({ customerReference }) {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });
  const [, , { setValue: setMultiAccount }] = useField('multiAccount');
  const [, , { setValue: setIsMultiAccountRequired }] = useField('isMultiAccountRequired');

  const {
    state: { multiAccounts, selectedCustomerReference, loaded },
  } = useMultiAccounts();

  const setDefaultMultiAccount = useCallback(async () => {
    const [{ accountDescription }] = multiAccounts;
    await setMultiAccount(accountDescription);
  }, [multiAccounts, setMultiAccount]);

  useEffect(() => {
    if (customerReference === selectedCustomerReference && loaded) {
      setIsMultiAccountRequired(Boolean(multiAccounts.length));
    }
  }, [
    customerReference,
    loaded,
    multiAccounts.length,
    selectedCustomerReference,
    setIsMultiAccountRequired,
  ]);

  // Set default multi account
  useEffect(() => {
    if (customerReference === selectedCustomerReference && loaded && multiAccounts.length === 1) {
      setDefaultMultiAccount();
    }
  }, [
    customerReference,
    loaded,
    multiAccounts.length,
    selectedCustomerReference,
    setDefaultMultiAccount,
  ]);

  return (
    <MultiAccountField
      disabled={multiAccounts && multiAccounts.length === 1}
      name={'multiAccount'}
      label={t('labels.multiAccount')}
      placeholder={t('placeholders.multiAccount')}
      customerReference={customerReference}
      productType={APP_PRODUCT_TYPE.CROP}
      required
    />
  );
}
